export const extractErrorCode = (error) =>
  error?.response?.details?.applicationError?.code ??
  error?.response?.data?.details?.applicationError?.code ??
  error?.response?.data?.errorCode ??
  error?.data?.errorCode ??
  error?.data?.reason ??
  error;
